import React, { useRef } from "react";
import SeoHelmet from "../components/SeoHelmet";
import Config from "../Config.json";
import { Link, useNavigate } from "react-router-dom";

const TITLE = Config.SITE_TITLE + " | Kontakt";
const DESC = "Create a React App from an HTML Website.";
const CANONICAL = Config.SITE_DOMAIN + "/";

const ContactDe = () => {
  const form = useRef();
  const navigate = useNavigate();

  const sendEmail = async (e) => {
  e.preventDefault();

  const formData = new FormData(form.current);
  const data = {
    name: formData.get("vezeteknev") + " " + formData.get("keresztnev"),
    email: formData.get("email"),
    message: formData.get("comment"),
  };

  try {
    const response = await fetch("https://aiinsidelife.com/api/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
      credentials: "include", // ha kell a session cookie
    });

    const result = await response.json();

    if (result.success) {
      alert("Message successfully sent!");
      e.target.reset();
    } else {
      alert("Error: " + result.message);
    }
  } catch (err) {
    console.error("Fetch error:", err);
    alert("An error occurred while sending the message.");
  }
};


  return (
    <main className="contact-main-content">
      <SeoHelmet
        title={`${Config.SITE_TITLE} | Contact`}
        description="Get in touch with us to share what AI topics you'd like to explore, AI tools, applications and insights."
        keywords={["AI", "Contact", "AI tools", "AI applications", "GPT-4", "Machine Learning"]}
        url={`${Config.SITE_DOMAIN}/en/Contact`}
        image="/images/og-contact.jpg"
        lang="en"
        author="Zsolt Fenyő"
      />
      
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact py-3 ps-3">Contact us</h1>
        </div>
        <div className="contact-content-container w-75">
          <p className="contact-margin-y1">
            Nehmen Sie Kontakt mit uns auf, um uns mitzuteilen, welche KI-Themen
            Sie erforschen möchten! Teilen Sie uns mit, ob es ein bestimmtes
            KI-Tool, einen bestimmten Aspekt oder eine bestimmte Anwendung gibt
            Sie sind neugierig, oder es gibt ein anderes Thema, bei dem wir uns
            melden können bieten Einblicke und Unterstützung. Wir sind hier, um
            Klarheit zu schaffen die Welt der KI.
          </p>
          <h2 className="contact-color">
            <b>Kontaktieren Sie uns direkt per E-Mail</b>
          </h2>
          <p>
            Email:{" "}
            <a
              className="contact-href"
              href="mailto:info@aiinsidelife.com?subject=Question%20regarding%20the%20everyday%20use%20of%20artificial%20intelligence&body=Dear%20AI%20Inside%20Life%20team,%0D%0A%0D%0AI%20am%20interested%20in%20the%20application%20of%20artificial%20intelligence%20solutions%20in%20everyday%20life.%20I%20would%20like%20to%20receive%20more%20information%20on%20the%20following%20topic:%0D%0A%0D%0A[Enter%20your%20questions%20or%20comments%20here]%0D%0A%0D%0ARegards,%0D%0A[Your%20name]"
              target="_top"
            >
              info@aiinsidelife.com
            </a>
          </p>
          <p>Facebook: facebook/aiinsidelife.com</p>
          <p>LinkedIn: [Insert Address]</p>
          <p>Twitter: [Insert Address]</p>

          {/* Form that sends email */}
          <form
            ref={form}
            onSubmit={sendEmail}
            className="contact-margin-y contact-color"
          >
            <h2>
              <b>
                Oder senden Sie uns eine Nachricht über das folgende Formular
              </b>
            </h2>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputVezNev" className="form-label">
                Vorname <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="vezeteknev"
                placeholder="Vorname"
                required
              />
            </div>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputKeresztNev" className="form-label">
                Nachname <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="keresztnev"
                placeholder="Nachname"
                required
              />
            </div>
            <div className="mt-4 mb-4">
              <label htmlFor="exampleInputEmail1" className="form-label">
                E-Mail-Adresse <span>*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                placeholder="E-Mail-Adresse"
                required
              />
              <div id="emailHelp" className="form-text">
                Wir geben Ihre E-Mail-Adresse niemals an Dritte weiter.
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="comment">
                Comment: <span>*</span>
              </label>
              <textarea
                className="form-control"
                rows="5"
                name="comment"
                required
              ></textarea>
            </div>
            <div className="mt-4 mb-4 form-check">
              <h6>
                Durch Klicken auf die Schaltfläche „Senden“ bestätige ich, dass
                ich I gelesen habe Sie haben die Datenschutzhinweise verstanden
                und akzeptieren diese auf deren Grundlage die Website meine
                Daten verwaltet.
              </h6>
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
                required
              />
              <label className="form-check-label" htmlFor="exampleCheck1">
                Ich bin damit einverstanden, dass meine von Aiinsidelife.com
                bereitgestellten persönlichen Daten - bis zum Widerruf meiner
                Einwilligung – für unmittelbare geschäftliche Zwecke
                (Informationen, öffentliche Meinung oder Marktforschung oder
                andere Information).
              </label>
            </div>
            <button type="submit" className="btn btn-Bosch-primary">
              Senden
            </button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default ContactDe;
